<div class="measure-button-container">
    <button  mat-mini-fab  class="map-control-button" aria-label="Measure" [ngClass]="{'active': isOpen()}" (click)="togglePanel($event)" 
    [matTooltip]="'measure.title' | translate" matTooltipPosition="left" >
        <mat-icon  fontSet="ngi" fontIcon="measure"></mat-icon>
    </button>
</div>

<!--    [ngClass]="{'active': !((state === measureState.SELECTED_LINE) || (state === measureState.DRAWING_LINE))}" -->

<!--  (click)="onClickMeasureButton($event)" -->

<!-- 
<button type="button" id="measure-button" [ngClass]="{
    'btn' : true, 
    'btn-info' : (state === measureState.OFF),
    'btn-light' : !(state === measureState.OFF)
}" (click)="onClickMeasureButton($event)">
    <span [ngClass]="{
        'fas': true,
        'fa-ruler': !((state === measureState.SELECTED_POLYGON) || (state === measureState.DRAWING_POLYGON)),
        'fa-ruler-combined': ((state === measureState.SELECTED_POLYGON) || (state === measureState.DRAWING_POLYGON))
      }">
    </span>
</button>
-->